import React, { useState, useEffect, useRef } from "react";
import "../Styles/about.css";

/* Feature cards using image icons */
const features = [
  {
    icon: "/assets/about_icon_1.png",
    title: "Industry Network",
    desc: "Connect with HR leaders, CXOs, and decision-makers across industries.",
  },
  {
    icon: "/assets/about_icon_2.png",
    title: "Brand Recognition",
    desc: "Increase your organization's visibility through premium HR platforms and events.",
  },
  {
    icon: "/assets/about_icon_3.png",
    title: "Knowledge Exchange",
    desc: "Share insights, showcase expertise, and establish thought leadership.",
  },
  {
    icon: "/assets/about_icon_4.png",
    title: "Talent Connect",
    desc: "Engage with universities, professionals, and the next generation of talent.",
  },
];

const brandPoints = [
  {
    title: "Leadership Branding",
    desc: "Position your brand as a trusted HR thought leader.",
  },
  {
    title: "Business Visibility",
    desc: "Increase brand awareness among HR professionals and industry leaders",
  },
  {
    title: "Community Engagement",
    desc: "Build meaningful relationships through exclusive HR events and communities.",
  },
  {
    title: "Future Workforce Access",
    desc: "Connect with academic institutions and emerging talent to build tomorrow's workforce.",
  },
];

export default function About() {
  // Section 2 entrance animation: starts when the section scrolls into view
  const [brandVisible, setBrandVisible] = useState(false);
  const brandRef = useRef(null);

  useEffect(() => {
    const el = brandRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setBrandVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="what-about-page">
      {/* ================= SECTION 1 ================= */}
      <section className="what-aboutpage-section what-aboutpage-section--one">
        <div className="what-about-container what-about-row">
          {/* LEFT CONTENT */}
          <div className="what-about-col what-about-col--left">
            <h2 className="what-aboutpage-heading">
              Building the Future of HR Through Community, Leadership &amp;
              Innovation
            </h2>

            <p className="what-aboutpage-text">
              Vanakkam HRD is one of India's fastest-growing HR communities,
              dedicated to bringing together HR leaders, business executives,
              people managers, academicians, and industry experts on a single
              platform. We create meaningful opportunities for learning,
              networking, collaboration, and professional growth through
              conferences, leadership summits, knowledge forums, awards, and
              community initiatives.
            </p>

            <p className="what-aboutpage-text">
              Our mission is to strengthen the HR ecosystem by fostering thought
              leadership, celebrating excellence, and enabling organizations to
              stay ahead in the ever-evolving world of work. By connecting
              industry and academia, showcasing innovative HR practices, and
              creating powerful networking experiences, we empower professionals
              and organizations to build future-ready workplaces.
            </p>

            <p className="what-aboutpage-text">
              At Vanakkam HRD, we don't just organize events—we build
              relationships, inspire leaders, and create communities that shape
              the future of Human Resources.
            </p>
          </div>

          {/* RIGHT FEATURE PANEL */}
          <div className="what-about-col what-about-col--right">
            <div className="what-feature-panel">
              <h3 className="what-feature-heading">Build Your HR Presence</h3>

              <div className="what-feature-grid">
                {features.map((f) => (
                  <div className="what-about-feature-card" key={f.title}>
                    <div className="what-feature-icon-box">
                      <img
                        src={f.icon}
                        alt=""
                        className="what-about-feature-icon"
                      />
                    </div>

                    <h4 className="what-feature-title">{f.title}</h4>

                    <p className="what-feature-desc">{f.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= SECTION 2 ================= */}
      <section
        className={`what-aboutpage-section what-aboutpage-section--two ${
          brandVisible ? "what-in-view" : ""
        }`}
        ref={brandRef}
      >
        <div className="what-about-container what-about-row what-about-row--reverse-mobile">
          {/* IMAGE */}
          <div className="what-about-col what-about-col--image">
            <div className="what-brand-image-wrap">
              <img
                src="/assets/About_image.png"
                alt="Business professionals shaking hands"
                className="what-brand-image"
              />
            </div>
          </div>

          {/* BRAND CONTENT */}
          <div className="what-about-col what-about-col--right">
            <h3 className="what-brand-heading">
              Empowering Brands Through HR Communities
            </h3>

            <p className="what-brand-subtext">
              Vanakkam HRD connects organizations with India's leading HR
              professionals through high-impact events, leadership forums, and
              community-driven initiatives that foster visibility, credibility,
              and lasting business relationships.
            </p>

            <div className="what-brand-card-list">
              {brandPoints.map((b, i) => (
                <div
                  className="what-brand-card"
                  key={b.title}
                  style={{ "--i": i }}
                >
                  <p className="what-brand-card-text">
                    <span className="what-brand-card-title">{b.title}</span>
                    {" – "}
                    {b.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}